export enum BusinessUnit
{
    Cutting = 1, 
    Planting = 2,  
}

export const enumLabel = (value?: BusinessUnit) => {
    switch (value) {
        case BusinessUnit.Cutting:
            return 'Срезка';
        case BusinessUnit.Planting:
            return 'Посадка';
        default:
            return '';
    }
};